<template>
  <b-card>
    <b-card-title>
      <h3>Item Description</h3>
    </b-card-title>
    {{ note }}
  </b-card>
</template>

<script>
import { BCard, BCardTitle } from 'bootstrap-vue'

export default {
  components: { BCard, BCardTitle },
  props: {
    note: {
      type: String,
      default: '',
    },
  },
}
</script>

<style></style>
